export const Price_LOADING = "Price_LOADING";
export const Price_FAILED = "Price_FAILED";
export const Price_SUCCESS = "Price_SUCCESS";

export interface PriceLoading {
  type: typeof Price_LOADING;
}

export interface PriceFail {
  type: typeof Price_FAILED;
}

export interface PriceSuccess {
  type: typeof Price_SUCCESS;
  payload: {
    price: any;
  };
}

export type PriceDispatchTypes = PriceLoading | PriceSuccess | PriceFail;
